export default __webpack_public_path__ + "static/media/1652.c7cff2b8.png";